// React
import { ReactElement } from 'react';
// Design System
import { Skeleton } from '@utmb/design-system/placeholder/Placeholder';
// Styles
import styles from './qualifiers-loader.module.scss';

interface QualifiersLoaderProps {
    limit: number;
}

export const QualifiersLoader = (props: QualifiersLoaderProps): ReactElement => {
    const { limit } = props;
    return (
        <div className={styles.loader}>
            <Skeleton height="20px" width="20%" />
            <div className={styles.loader_spacer} />
            {[...new Array(limit)].map((v, i) => (
                <div key={i} className={`container p-0 ${styles.loader_card}`}>
                    <div className="row">
                        <div className="col-3 col-lg-2">
                            <Skeleton height="160px" width="100%" />
                        </div>
                        <div className="col-9 col-lg-10">
                            <div className={`row ${styles.loader_card_content}`}>
                                <div className="col-lg-8 col-xl-9">
                                    <div className={`row ${styles.loader_card_content_spacer}`}>
                                        <div className="col-6">
                                            <Skeleton height="40px" width="90%" />
                                        </div>
                                        <div className="col-6">
                                            <Skeleton height="30px" width="90%" />
                                        </div>
                                    </div>
                                    <div className={`row ${styles.loader_card_stats}`}>
                                        <div className="col-lg-6 col-xl-3 mb-3">
                                            <Skeleton height="30px" width="60%" />
                                        </div>
                                        <div className="col-lg-6 col-xl-3 mb-3">
                                            <Skeleton height="30px" width="60%" />
                                        </div>
                                        <div className="col-lg-6 col-xl-3 mb-3">
                                            <Skeleton height="30px" width="60%" />
                                        </div>
                                        <div className="col-lg-6 col-xl-3 mb-3">
                                            <Skeleton height="30px" width="60%" />
                                        </div>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-xl-3 ${styles.loader_card_content_buttons}`}>
                                    <Skeleton height="70px" width="100%" />
                                    <Skeleton height="70px" width="100%" />
                                </div>
                            </div>
                        </div>
                        <div className={styles.loader_card_border}>
                            <Skeleton height="5px" width="100%" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
